<!-- Breadcrumb -->
<div class="mb-4 flex items-center gap-2 text-sm text-gray-600">
  <a
    [routerLink]="['/insider-trading-plans']"
    class="text-blue-600 hover:underline cursor-pointer"
  >
    Insider Trading Plans
  </a>
  <i class="pi pi-angle-right text-gray-400"></i>
  <span class="text-gray-900 font-medium">
    {{ issuerName ? issuerName : "" }}
  </span>
</div>

<p-card class="shadow-lg mb-5" [style]="{ 'border-radius': '0.5rem',  }">
  <!-- Responsive grid -->
  <div
    class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4"
  >
    <div class="flex flex-col">
  <label class="block text-sm font-medium mb-1">FID</label>

  <input
    pInputText
    type="text"
    pSize="small"
    placeholder="Search FID..."
    class="w-full"

    [(ngModel)]="filters.filingId"
    #filingIdCtrl="ngModel"
    pattern="^[0-9]*$"

    (keydown.enter)="onSubmitFilters()"
    (keydown)="preventSpaceKey($event)"
    (paste)="onPaste($event, 'filingId')"
  />

  <!-- Validation message (right below, no logic change) -->
  <small
    class="text-red-600 text-xs mt-1 min-h-[1rem]"
    *ngIf="filingIdCtrl.invalid && (filingIdCtrl.dirty || filingIdCtrl.touched)"
  >
    Filing ID must be an integer.
  </small>
</div>


    <!-- Insider -->
    <div>
      <label class="block text-sm font-medium mb-1">Insider Name</label>
      <p-multiSelect
        [options]="insiderList"
        [(ngModel)]="selectedInsiderNames"
        optionLabel="insiderName"
        placeholder="Select insiders..."
        class="w-full"
        [filter]="true"
        filterPlaceholder="Search insiders..."
        size="small"
        (onChange)="onInsiderSelectionChange()"
        [showToggleAll]="false"
      ></p-multiSelect>
    </div>

    <!-- Plan Action -->
    <div>
      <label class="block text-sm font-medium mb-1">Plan Action</label>
      <p-dropdown
        [options]="planActions"
        [(ngModel)]="filters.planAction"
        placeholder="Select Action"
        class="w-full"
        size="large"
        (onChange)="onSubmitFilters()"
      ></p-dropdown>
    </div>

    <div>
      <label class="block text-sm font-medium mb-1">Tags</label>
      <div class="flex flex-wrap sm:flex-nowrap gap-2">
        <p-multiSelect
          [options]="tags"
          [(ngModel)]="selectedTags"
          defaultLabel="Select tags"
          class="flex-1 min-w-[150px]"
          [showToggleAll]="false"
          size="small"
          [disabled]="!selectedInsiders.length"
          [showToggleAll]="false"
          [filter]="false"
          size="small"
          (onChange)="onTagSelection()"
          optionDisabled="disable"
        ></p-multiSelect>

        <button
          pButton
          type="button"
          label="Apply"
          class="p-button-success shrink-0"
          [disabled]="!selectedInsiders.length "
          (click)="onApplyTags()"
        ></button>
      </div>
    </div>

    <!-- Announcement Date (From) -->
    <div>
      <label class="block text-sm font-medium mb-1"
        >Announcement Date (From)</label
      >
      <p-datepicker
        appendTo="body"
        dateFormat="mm-dd-yy"
        placeholder="mm-dd-yyyy"
        class="w-full p-0 h-4"
        [size]="'small'"
        (onSelect)="onSubmitFilters()"
        [style]="{ width: '100%' }"
        [(ngModel)]="filters.filingDateFrom"
        [showClear]="true"
        (onClear)="onSubmitFilters()"
        [showIcon]="true"
      ></p-datepicker>
    </div>

    <!-- Announcement Date (To) -->
    <div>
      <label class="block text-sm font-medium mb-1"
        >Announcement Date (To)</label
      >
      <p-datepicker
        appendTo="body"
        dateFormat="mm-dd-yy"
        placeholder="mm-dd-yyyy"
        class="w-full h-4"
        [style]="{ width: '100%' }"
        (onSelect)="onSubmitFilters()"
        [(ngModel)]="filters.filingDateTo"
        [size]="'small'"
        [showClear]="true"
        (onClear)="onSubmitFilters()"
        [showIcon]="true"
      ></p-datepicker>
    </div>

    <!-- Include Indeterminable -->
    <div class="flex items-center gap-2 mt-6">
      <p-checkbox
        binary="true"
        [(ngModel)]="filters.includeIndeterminable"
        inputId="includeIndeterminable"
        (onChange)="onSubmitFilters()"
      ></p-checkbox>
      <label for="includeIndeterminable">Include Indeterminable</label>
    </div>
    <!-- Duplicate  Filings -->
    <!-- <div class="flex items-center gap-2 mt-6">
      <p-checkbox
        binary="true"
        [(ngModel)]="filters.filingInDuplicateQualityGate"
        inputId="filingInDuplicateQualityGate"
        (onChange)="onSubmitFilters()"
      ></p-checkbox>
      <label for="filingInDuplicateQualityGate">FilingId Duplicate Quality Gate</label>
    </div> -->
    <!-- Duplicate  Plans -->
    <div class="flex items-center gap-2 mt-6">
      <p-checkbox
        binary="true"
        [(ngModel)]="filters.tradingPlanInDuplicateQualityGate"
        inputId="tradingPlanInDuplicateQualityGate"
        (onChange)="onSubmitFilters()"
      ></p-checkbox>
      <label for="tradingPlanInDuplicateQualityGate"
        >Trading PlanId Duplicate Quality Gate</label
      >
    </div>
    <!-- Modified Plans Filter -->
    <div class="flex items-center gap-2 mt-6">
      <p-checkbox
        binary="true"
        [(ngModel)]="filters.hasModifiedFields"
        inputId="hasModifiedFields"
        (onChange)="onSubmitFilters()"
      ></p-checkbox>
      <label for="hasModifiedFields"
        >Show Only Modified Plans</label
      >
    </div>
  </div>

  <!-- Clear Filters -->
  <div class="flex justify-end">
    <button
      pButton
      label="Clear All Filters"
      icon="pi pi-filter-slash"
      class="p-button-secondary"
      [disabled]="!isFiltersActive()"
      [ngClass]="{
        'opacity-50 cursor-not-allowed': !isFiltersActive(),
        'bg-clear-button': isFiltersActive()
      }"
      (click)="clearFilters()"
    ></button>
  </div>
</p-card>

<!--  PrimeNG Table -->

<!-- Show insider details table when insiders are selected -->
<div class="mt-4" *ngIf="selectedInsiderNames && selectedInsiderNames.length > 0">
  <p-table
    [value]="groupedInsiderDetails"
    styleClass="p-datatable-gridlines"
    [(selection)]="selectedInsiders"
    (selectionChange)="onSelectionChange($event)"
    [paginator]="groupedInsiderDetails.length > 0"
    [first]="insiderDetailsFirst"
    [lazy]="false"
    [totalRecords]="insiderDetailsPaginator.totalCount"
    [rows]="insiderDetailsPaginator.pageSize"
    [loading]="isLoading"
    [showCurrentPageReport]="true"
    [tableStyle]="{ 'min-width': '50rem' }"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
    (onPage)="pageChangeInsiderDetails($event)"
    dataKey="asReportedSecurityBreakdownId"
    [rowsPerPageOptions]="[10, 25, 50]"
    styleClass="fixed-table"
  >
    <ng-template pTemplate="header">
      <tr>
        <th style="width: 4rem">
          <p-tableHeaderCheckbox />
        </th>
        <th>Filing Date</th>
        <th>FID</th>
        <th>Trading PlanId</th>
        <th>Insider Name</th>
        <th>D/I</th>
        <th>Plan Action</th>
        <th>Adoption Date</th>
        <th>Effective Date</th>
        <th>Amendment Date</th>
        <th>Termination Date</th>
        <th>Expiration Date</th>
        <th>Security</th>
        <th>Transaction</th>
        <th>Shares</th>
        <th>Shares Description</th>
        <th>Notional Value</th>
        <th>Link</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-group>
      <tr class="bg-light-row font-semibold">

        <td colspan="17" class="">
          <span class="cursor-pointer">
            {{ group.insiderName || '-' }}
          </span>
        </td>
      </tr>

      <ng-container *ngFor="let plan of group.plans">
        <tr [ngClass]="{ 'highlight-plan-row': plan.tradingPlanStatus === 'DUPLICATE' }">
           <td>
          <p-tableCheckbox [value]="plan" />
        </td>
          <td class="cell-ellipsis">
            {{ plan.filingDate }}
          </td>
          <td class="cell-ellipsis">
            {{ plan.filingId }}
            <sup
              *ngIf="plan.modifiedFields?.modifiedOther"
              class="text-xs px-1 rounded bg-yellow-300 text-gray-900 font-semibold"
              >O</sup
            >
          </td>
          <td>
            {{ plan.tradingPlanId }}
          </td>
          <td>
            {{ plan.insiderName }}
          </td>
          <td>
            <span
              [pTooltip]="plan.relationInsiderName"
              [tooltipDisabled]="(plan?.relationType ?? '').toString().trim().toUpperCase() !== 'I'"
              tooltipPosition="top"
              tooltipStyleClass="tooltip-single-line"
              [style.cursor]="((plan?.relationType ?? '').toString().trim().toUpperCase() === 'I') ? 'pointer' : 'default'"
            >
              {{ plan.relationType }}
            </span>
          </td>
          <td>
            <div class="flex items-center gap-1">
              <!-- Plan Action Label -->
              <span
                class="px-2 py-1 rounded text-xs font-medium"
                [ngClass]="{
                  'bg-blue-100 text-blue-700':
                    plan.planAction?.toLowerCase() === 'adoption',
                  'bg-purple-100 text-purple-700':
                    plan.planAction?.toLowerCase() === 'amendment',
                  'bg-yellow-100 text-yellow-700':
                    plan.planAction?.toLowerCase() === 'termination'
                }"
              >
                {{ plan.planAction | titlecase }}
              </span>

              <!-- SUP (Modification Badge) -->
              <sup
                *ngIf="plan.modifiedFields?.modifiedPlanAction"
                class="text-xs px-1 rounded bg-yellow-300 text-gray-900 font-semibold"
              >
                M
              </sup>
            </div>
          </td>

          <td class="cell-ellipsis">
            {{ plan.adoptionDate }}
            <sup
              *ngIf="plan.modifiedFields?.modifiedAdoptionDate"
              class="ml-1 text-xs px-1 rounded bg-yellow-300 text-gray-900 font-semibold"
              >M</sup
            >
            <sup
              *ngIf="plan.isEstimateAdoptionDate"
              class="ml-1 text-xs px-1 rounded bg-yellow-300 text-gray-900 font-semibold"
              >E</sup
            >
          </td>
          <td class="cell-ellipsis">
            {{ plan.effectiveDate }}
            <sup
              *ngIf="plan.modifiedFields?.modifiedEffectiveDate"
              class="ml-1 text-xs px-1 rounded bg-yellow-300 text-gray-900 font-semibold"
              >M</sup
            >
          </td>
          <td class="cell-ellipsis">
            {{ plan.amendmentDate }}
            <sup
              *ngIf="plan.modifiedFields?.modifiedAmendmentDate"
              class="ml-1 text-xs px-1 rounded bg-yellow-300 text-gray-900 font-semibold"
              >M</sup
            >
            <sup
              *ngIf="plan.isEstimateAmendedDate"
              class="ml-1 text-xs px-1 rounded bg-yellow-300 text-gray-900 font-semibold"
              >E</sup
            >
          </td>
          <td class="cell-ellipsis">
            {{ plan.terminationDate }}
            <sup
              *ngIf="plan.modifiedFields?.modifiedTerminationDate"
              class="ml-1 text-xs px-1 rounded bg-yellow-300 text-gray-900 font-semibold"
              >M</sup
            >
            <sup
              *ngIf="plan.isEstimateTerminationDate"
              class="ml-1 text-xs px-1 rounded bg-yellow-300 text-gray-900 font-semibold"
              >E</sup
            >
          </td>
          <td class="cell-ellipsis">
            {{ plan.expirationDate }}
            <sup
              *ngIf="plan.modifiedFields?.modifiedExpirationDate"
              class="ml-1 text-xs px-1 rounded bg-yellow-300 text-gray-900 font-semibold"
              >M</sup
            >
          </td>
          <td>{{ plan.security }}</td>
          <td>
            <div class="flex items-center space-x-1 flex-nowrap">
              <span
                [ngClass]="{
                  'transaction-buy':
                    plan.Transaction?.toLowerCase().startsWith('buy'),
                  'transaction-sell':
                    plan.Transaction?.toLowerCase().startsWith('sell')
                }"
              >
                {{ plan.Transaction?.split(" ")[0] || plan.Transaction || "-" }}
                <span
                  class="transaction-code"
                  *ngIf="plan.Transaction?.split(' ')?.[1]"
                  >{{ plan.Transaction?.split(" ")[1] }}</span
                >
              </span>
              <sup
                *ngFor="
                  let tag of getStringForTransactionTags(
                    plan.asReportedSecurityBreakdownTags
                  )
                "
                class="ml-1 text-xs px-1 rounded bg-yellow-300 text-gray-900 font-semibold"
              >
                {{ tag }}
              </sup>
              <sup
                *ngIf="plan.modifiedFields?.modifiedTransactionType"
                class="text-xs px-1 rounded bg-yellow-300 text-gray-900 font-semibold"
              >
                M
              </sup>
            </div>
          </td>
          <td class="cell-ellipsis">
            {{ plan.shares | number : "1.0-0" }}
            <sup
              *ngIf="plan.modifiedFields?.modifiedNumberOfShares"
              class="ml-1 text-xs px-1 rounded bg-yellow-300 text-gray-900 font-semibold"
              >M</sup
            >
          </td>
          <td
            class="cell-ellipsis"
            [pTooltip]="plan.sharesDescription"
            tooltipPosition="top"
          >
            {{ plan.sharesDescription }}
          </td>
          <td>{{ plan.nationalValue }}</td>
          <td>
            <a
              [href]="plan.filingLink"
              target="_blank"
              rel="noopener noreferrer"
              class="text-blue-500 cursor-pointer flex items-center gap-1"
            >
              <i class="pi pi-link"></i>
            </a>
          </td>
        </tr>
      </ng-container>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="18" class="w-full text-center text-gray-500 py-4">
          No records found
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>

<!-- Show main table when no insiders are selected -->
<div class="mt-4" *ngIf="!selectedInsiderNames || selectedInsiderNames.length === 0">
  <p-table
    [value]="insiderTradingPlans"
    styleClass="p-datatable-gridlines"
    [(selection)]="selectedInsiders"
    (selectionChange)="onSelectionChange($event)"
    [paginator]="insiderTradingPlans.length > 0"
    [first]="first"
    (onLazyLoad)="loadData($event)"
    [lazy]="true"
    [totalRecords]="paginator.totalCount"
    [rows]="paginator.pageSize"
    [loading]="isLoading"
    [showCurrentPageReport]="true"
    [tableStyle]="{ 'min-width': '50rem' }"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
    (onPage)="pageChange($event)"
    dataKey="asReportedSecurityBreakdownId"
    [rowsPerPageOptions]="[10, 25, 50]"
    (selectionChange)="onSelectionChange($event)"
    styleClass="fixed-table"
  >
    <ng-template pTemplate="header">
      <tr>
        <th style="width: 4rem">
          <p-tableHeaderCheckbox />
        </th>
        <th>Filing Date</th>
        <th>FID</th>
        <th>Trading PlanId</th>
        <th>Insider Name</th>
        <!-- <th>Relation</th> -->
        <th>D/I</th>
        <th>Plan Action</th>
        <th>Adoption Date</th>
        <th>Effective Date</th>
        <th>Amendment Date</th>
        <th>Termination Date</th>
        <th>Expiration Date</th>
        <th>Security</th>
        <th>Transaction</th>
        <th>Shares</th>
        <th>Shares Description</th>
        <th>Notional Value</th>
        <th>Link</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-plan>
      <tr
        [ngClass]="{
          'highlight-plan-row': plan.tradingPlanStatus === 'DUPLICATE'
        }"
      >
        <td>
          <p-tableCheckbox [value]="plan" />
        </td>
        <td class="cell-ellipsis">
          {{ plan.filingDate }}
        </td>
        <td class="cell-ellipsis">
          {{ plan.filingId }}
          <sup
            *ngIf="plan.modifiedFields?.modifiedOther"
            class="text-xs px-1 rounded bg-yellow-300 text-gray-900 font-semibold"
            >O</sup
          >
        </td>
        <td>
          {{ plan.tradingPlanId }}
        </td>
        <td class="">
          <span >
            {{ plan.insiderName }}
          </span>
        </td>
        <!-- <td>{{ plan.relation }}</td> -->
        <td>
          <ng-container *ngIf="(plan?.relationType ?? '').toString().trim().toUpperCase() === 'I'; else noTooltip2">
            <span
              [pTooltip]="plan.relationInsiderName"
              tooltipPosition="top"
              tooltipStyleClass="tooltip-relation-type"
              style="cursor: pointer;"
            >
              {{ plan.relationType }}
            </span>
                  </ng-container>

                  <ng-template #noTooltip2>
            <span style="cursor: default;">
              {{ plan.relationType }}
            </span>
          </ng-template>
        </td>
        <td>
          <div class="flex items-center gap-1">
            <!-- Plan Action Label -->
            <span
              class="px-2 py-1 rounded text-xs font-medium"
              [ngClass]="{
                'bg-blue-100 text-blue-700':
                  plan.planAction?.toLowerCase() === 'adoption',
                'bg-purple-100 text-purple-700':
                  plan.planAction?.toLowerCase() === 'amendment',
                'bg-yellow-100 text-yellow-700':
                  plan.planAction?.toLowerCase() === 'termination'
              }"
            >
              {{ plan.planAction | titlecase }}
            </span>

            <!-- SUP (Modification Badge) -->
            <sup
              *ngIf="plan.modifiedFields?.modifiedPlanAction"
              class="text-xs px-1 rounded bg-yellow-300 text-gray-900 font-semibold"
            >
              M
            </sup>
          </div>
        </td>

        <td class="cell-ellipsis">
          {{ plan.adoptionDate }}
          <sup
            *ngIf="plan.modifiedFields?.modifiedAdoptionDate"
            class="ml-1 text-xs px-1 rounded bg-yellow-300 text-gray-900 font-semibold"
            >M</sup
          >
          <sup
            *ngIf="plan.isEstimateAdoptionDate"
            class="ml-1 text-xs px-1 rounded bg-yellow-300 text-gray-900 font-semibold"
            >E</sup
          >
        </td>
        <td class="cell-ellipsis">
          {{ plan.effectiveDate }}
          <sup
            *ngIf="plan.modifiedFields?.modifiedEffectiveDate"
            class="ml-1 text-xs px-1 rounded bg-yellow-300 text-gray-900 font-semibold"
            >M</sup
          >
        </td>
        <td class="cell-ellipsis">
          {{ plan.amendmentDate }}
          <sup
            *ngIf="plan.modifiedFields?.modifiedAmendmentDate"
            class="ml-1 text-xs px-1 rounded bg-yellow-300 text-gray-900 font-semibold"
            >M</sup
          >
            <sup
              *ngIf="plan.isEstimateAmendedDate"
              class="ml-1 text-xs px-1 rounded bg-yellow-300 text-gray-900 font-semibold"
              >E</sup
            >
        </td>
        <td class="cell-ellipsis">
          {{ plan.terminationDate }}
          <sup
            *ngIf="plan.modifiedFields?.modifiedTerminationDate"
            class="ml-1 text-xs px-1 rounded bg-yellow-300 text-gray-900 font-semibold"
            >M</sup
          >
          <sup
            *ngIf="plan.isEstimateTerminationDate"
            class="ml-1 text-xs px-1 rounded bg-yellow-300 text-gray-900 font-semibold"
            >E</sup
          >
        </td>
        <td class="cell-ellipsis">
          {{ plan.expirationDate }}
          <sup
            *ngIf="plan.modifiedFields?.modifiedExpirationDate"
            class="ml-1 text-xs px-1 rounded bg-yellow-300 text-gray-900 font-semibold"
            >M</sup
          >
        </td>
        <td>{{ plan.security }}</td>
        <td>
          <div class="flex items-center space-x-1 flex-nowrap">
            <span
              [ngClass]="{
                'transaction-buy':
                  plan.Transaction?.toLowerCase().startsWith('buy'),
                'transaction-sell':
                  plan.Transaction?.toLowerCase().startsWith('sell')
              }"
            >
              {{ plan.Transaction?.split(" ")[0] || plan.Transaction || "-" }}
              <span
                class="transaction-code"
                *ngIf="plan.Transaction?.split(' ')?.[1]"
                >{{ plan.Transaction?.split(" ")[1] }}</span
              >
            </span>
            <sup
              *ngFor="
                let tag of getStringForTransactionTags(
                  plan.asReportedSecurityBreakdownTags
                )
              "
              class="ml-1 text-xs px-1 rounded bg-yellow-300 text-gray-900 font-semibold"
            >
              {{ tag }}
            </sup>
            <sup
              *ngIf="plan.modifiedFields?.modifiedTransactionType"
              class="text-xs px-1 rounded bg-yellow-300 text-gray-900 font-semibold"
            >
              M
            </sup>
          </div>
        </td>

        <td class="cell-ellipsis">
          {{ plan.shares | number : "1.0-0" }}
          <sup
            *ngIf="plan.modifiedFields?.modifiedNumberOfShares"
            class="ml-1 text-xs px-1 rounded bg-yellow-300 text-gray-900 font-semibold"
            >M</sup
          >
        </td>
        <td
          class="cell-ellipsis"
          [pTooltip]="plan.sharesDescription"
          tooltipPosition="top"
        >
          {{ plan.sharesDescription }}
        </td>
        <td>{{ plan.nationalValue }}</td>
        <td>
          <a
            [href]="plan.filingLink"
            target="_blank"
            rel="noopener noreferrer"
            class="text-blue-500 cursor-pointer flex items-center gap-1"
          >
            <i class="pi pi-link"></i>
          </a>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="11" class="w-full text-center text-gray-500 py-4">
          No records found
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
<p-toast></p-toast>

<!-- </div> -->
